import { Typography, styled } from '@mui/material';

const TextName = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};

  padding: 8px 0;
`;

export default TextName;
